/**
 * @desc: - Banner- 大小依赖父级，可按左右甜头切换，按圆点切换
 * @param  {[ARRAY]} ：list [banners list 数组 对象{path:"", href: ""}]
 * @author: vico
 */
import React from 'react';
import { LOTTERY_MENUS } from '../../constants/menus/lotteryMenus'

export default class FullScreenBanner extends React.Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    // 当前显示图片index
    this.state = {
      current: 0
    }
  }

  // 启动自动滚动定时器
  componentDidMount(){
    this.goPaly();
  }

  // 销毁自动滚动定时器
  componentWillUnmount(){
    clearInterval(this.autoPalyFlag)
  }

  // 切换当前显示图片index
  changeCurrentDisplay(index){
    if (index === 'prev') {
      // 上一个
      this.turn(-1);
    }
    if (index === 'next') {
      // 下一个
      this.turn(1);
    }
  }

  // 自动切换
  turn(n){
    var _n = this.state.current +n;
    if(_n<this.props.list.length  && _n>=0){
      this.setState({current:_n})
    }else{
      if(_n == -1){
        this.setState({current:this.props.list.length -1})
        return;
      }
      this.setState({current:0})
    }
  }

  // 开始自动轮播
  goPaly(){
    this.autoPalyFlag = setInterval(()=>{
      this.turn(1);
    },2000)
  }

  // 点击轮播图
  handleClick(link){
    const activityRex =/\.*\/activity\/.*/;
    const betRex = /\.*\/lottery\/.*/;
    // 活动链接
    if (activityRex.test(link) && !_.includes(link, '.html') ) {
      const aid = _.last(_.split(link, '/'))
      return window.location.href = '#/activity/' + aid
    }
    // 投注页
    if (betRex.test(link) && !_.includes(link, '.html')) {
      const flaglot = _.last(_.split(link, '/'));
      const lotterys = _.concat(..._.map(LOTTERY_MENUS, 'lotterys'));
      const _lottery = _.find(lotterys, {flaglot: flaglot});
      return window.location.href = _lottery.uri;
    }
    if(_.trim(link)==""){
      return
    }
    // 其他页新窗口打开
    window.open(link);
  }

  // 鼠标移入小圆点事件
  mouseover(i){
    this.setState({current:i});
  }

  //暂停自动轮播
  pausePlay(){
    clearInterval(this.autoPalyFlag)
  }
  render() {
    const { list } = this.props;
    return (
          <div className="banner-box"  onMouseOver={this.pausePlay.bind(this)} onMouseOut={this.goPaly.bind(this)}>
            <ul className="banner_box">
              {
                list.map((item,i)=>{
                  return  <li key={i}  
                            className ={this.state.current == i?'cur':''}>
                            <a style={{backgroundImage:`url(${item.picture})`}} onClick={this.handleClick.bind(this, item.link)} className='pointer' title={item.title}>
                            </a>
                          </li>
                })
              }
            </ul>
            <div className="banner_radio">
              <ul className="banner_radios">
                {
                  list.map((item,i)=>{
                    return <li key={i} onMouseOver={this.mouseover.bind(this,i)} className ={this.state.current == i?'cur':''}></li>
                  })
                }
              </ul>
            </div>
          </div>
         
    );
  }
}
